<template>
  <img
    class="asset-image"
    :src="image"
    :alt="altText"
  />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  altText: {
    type: String,
    default: '',
  },
})

const image = computed(
  () => new URL(`../assets/img/${props.name}`, import.meta.url).href,
)
</script>
